"use client";

import { useEffect, useState } from "react";

import { getAgelessAdminBaseUrl } from "./host.utils";

/**
 * Resolves the Ageless site base URL safely for client components.
 *
 * The initial render avoids reading from `window`. After mount, the hook resolves
 * from `window.location.hostname` so local, preview, dev, and production hosts
 * map to the matching Ageless site URL.
 */
export function useAgelessAdminBaseUrl(): string | undefined {
  const [agelessAdminBaseUrl, setAgelessAdminBaseUrl] = useState(() => getAgelessAdminBaseUrl());

  useEffect(() => {
    setAgelessAdminBaseUrl(getAgelessAdminBaseUrl(window.location.hostname));
  }, []);

  return agelessAdminBaseUrl;
}
